import 'flatpickr/dist/flatpickr.js';
import 'flatpickr/dist/flatpickr.css';

import '../resources/behaviors/flatpickr';
